var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("SweetAlert2 Test Component")]),_c('p',[_vm._v("If you see a popup, try to close it by clicking outside, pressing Escape, or clicking the button.")])])
}]

export { render, staticRenderFns }